import { Box, Grid, TextField } from "@mui/material"
import React, { useEffect, useState } from "react"
import RegisterHeader from "../../../components/register-header/RegisterHeader"
import CustomModal from "../../../components/modal/CustomModal"
import NepaliCalender from "../../../components/nepali-calender"
import CustomReactSelect from "../../../components/custom-react-select/CustomReactSelect"
import AdmissionRegister from "../../users/components/register/admission-register/AdmissionRegister"
import { useForm } from "react-hook-form"
import { AYURVEDIC_THERAPY, CASTE_CODES, ERROR, GENDER_OPTIONS, PATIENT_TYPES, POLICE_CASE, REQUIRED_FIELD, ROW_PER_PAGE, SOMETHING_WENT_WRONG, SOURCE_OF_ADMISSION, SUCCESS } from "../../../utils/constants"
import { AppMisc } from "../../../misc/appMisc"
import AHMIS, { API_URL } from "../../../api/api"
import AddAlertMessage from "../../../components/alert/Alert"
import DeleteRegisterRecordConformation from "../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation"
import { AGE_UNITS } from "../../../utils/constants/forms"

const AdmissionForm = () => {
  const [modalTitle, setModalTitle] = useState("Admission Register")
  const [modalDefaultValues, setModalDefaultValues] = useState();
  const [palikaOptions, setPalikaOptions] = useState([]);
  const [getTableData, setGetTableData] = useState(false);
  const [showAdmission, setShowAdmission] = useState(false)
  const [admisssionSewaTableData, setAdmisssionSewaTableData] = useState([]);
  const [showAdmissionRegisterDeleteModal, setShowAdmissionRegisterDeleteModal] = useState(false);
  const [page, setPage] = useState(0);
  const [totalSize, setTotalSize] = useState(0);
  const [admissionDeleteId, setAdmissionDeleteId] = useState(null);
  const districtOptions = AppMisc.getDistrictOptions();
  const { register, handleSubmit, setValue, formState: { errors }, reset, } = useForm();

  const openAdmissionModal = () => {
    setShowAdmission(true)
  }

  const closeAdmissionModal = () => {
    setShowAdmission(false);
    setModalDefaultValues();
    reset();
  }

  const handlePalikaNameChange = (name, value) => {
    setValue(name, value);
  };

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  };

  useEffect(() => {
    register("date", { required: true });
    register("patientType", { required: true });
    register("casteCode", { required: true });
    register("district", { required: true });
    register("municipality", { required: true });
    register("sourceOfAdmission", { required: true });
    register("ayurvedicTherapy", { required: true });
    register("ageUnit", { required: true });
    register("policeCase", { required: true });
    register("gender", { required: true });
  }, [register]);

  useEffect(() => {
    showAdmission && reset();
  }, [reset, showAdmission]);

  const handleCustomReactSelectChange = (name, value) => {
    setValue(name, value);
  };

  const handleDistrictChange = (name, value, districtOption) => {
    setValue("palikaName", null);
    setValue(name, value);
    districtOption && setPalikaOptions(districtOption.palikas || []);
  };

  const submitAdmissionRegister = (data) => {
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    AHMIS.post(API_URL.admission, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closeAdmissionModal();
          setGetTableData(true);
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const getAdmissionSewa = (fromDate, toDate, searchParam, healthClientId, pageFromParam) => {
    let url = `${API_URL.admission}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(page) + 1)}&rowSize=${ROW_PER_PAGE}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParam) {
      url = url + "&searchParam=" + searchParam;
    }
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        setGetTableData(false);
        setAdmisssionSewaTableData(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.size)
      })
      .catch(error => {
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
      });
  }

  const admissionSewaEdit = (id) => {
    AHMIS.get(API_URL.admission + "/" + id)
      .then(response => {
        setModalDefaultValues(response.data);
        setShowAdmission(true);
        if (response.data.district && response.data.palikaName) {
          populateDistrictAndPalikaName(response.data.district, response.data.palikaName);
        }
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const populateDistrictAndPalikaName = (districtName, palikaName) => {
    let districtObject = districtOptions.find(options => options.value === districtName);
    handleDistrictChange("district", districtName, districtObject);
    handlePalikaNameChange("palikaName", palikaName);
  }

  const closeAdmissionDeleteModal = () => {
    setShowAdmissionRegisterDeleteModal(false)
    setAdmissionDeleteId(null);
  }

  const onDeleteAdmissionRow = (id) => {
    setShowAdmissionRegisterDeleteModal(true)
    setAdmissionDeleteId(id);
  }

  const deleteAdmissionRow = (data) => {
    AHMIS.delete(API_URL.admission + "/" + admissionDeleteId + "?deleteReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowAdmissionRegisterDeleteModal(false);
          setAdmissionDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          setGetTableData(true);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    setPage(0)
    getAdmissionSewa(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const handleChangePage = (newPage) => {
    setPage(newPage);
    setGetTableData(true);
  };

  return (
    <>
      <Box marginTop={2}>
        <RegisterHeader
          registerTitle="Admission Register"
          handleModalOpen={openAdmissionModal}
          getRegisterData={getAdmissionSewa}
          onHeaderParamChange={onHeaderParamChange}
          getTableData={getTableData}
          fromDateDefaultFormat
          lazyLoading
          showSearchField
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showAdmission}
        onModalSubmit={handleSubmit(submitAdmissionRegister)}
        onModalClose={closeAdmissionModal}
        maxWidth="lg"
        fullScreen>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <Box>
              <NepaliCalender
                id="mul-dartaa-dartaa-miti"
                name="dartaaMiti"
                showDefaultDate
                label="दर्ता मिति"
                onChange={handleDateChange}
                defaultDate={modalDefaultValues?.dartaaMiti}
              />
              {errors?.dartaaMiti && errors.dartaaMiti?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Time of Admission"
              type="time"
              size="small"
              variant="outlined"
              name="timeOfAdmission"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.timeOfAdmission}
              {...register("timeOfAdmission")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="Patient Type"
              name="patientType"
              options={PATIENT_TYPES}
              onChange={handleCustomReactSelectChange}
              defaultValue={modalDefaultValues?.patientType}
            />
            {errors?.patientType && errors.patientType?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="दर्ता नम्बर"
              type="number"
              size="small"
              variant="outlined"
              name="dartaaNumber"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.dartaaNumber}
              {...register("dartaaNumber")}
            />
            {errors?.dartaaNumber && errors.dartaaNumber?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Name"
              type="text"
              size="small"
              variant="outlined"
              name="name"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.dartaaNumber}
              {...register("name")}
            />
            {errors?.name && errors.name?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Family Name"
              size="small"
              type="text"
              variant="outlined"
              name="familyName"
              autoComplete="true"
              InputLabelProps={{ shrink: true }}
              fullWidth
              defaultValue={modalDefaultValues?.name}
              {...register("familyName")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="Caste Code"
              type="text"
              size="small"
              variant="outlined"
              name="casteCode"
              autoComplete="true"
              fullWidth
              options={CASTE_CODES}
              onChange={handleCustomReactSelectChange}
              defaultValue={modalDefaultValues?.casteCode}
            />
            {errors?.casteCode && errors.casteCode?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="लिङ्ग"
              name="gender"
              size="small"
              fullWidth
              onChange={handleCustomReactSelectChange}
              defaultValue={modalDefaultValues?.gender}
              options={GENDER_OPTIONS}
            />
            {errors?.gender && errors.gender?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="उमेर"
              size="small"
              type="number"
              variant="outlined"
              name="age"
              autoComplete="true"
              InputLabelProps={{ shrink: true }}
              fullWidth
              defaultValue={modalDefaultValues?.age}
              {...register("age")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="उमेर वर्ष वा महिना"
              name="ageUnit"
              options={AGE_UNITS}
              defaultValue={modalDefaultValues?.ageUnit}
              onChange={handleCustomReactSelectChange}
            />
            {errors?.ageUnit && errors.ageUnit?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="District"
              name="district"
              variant="outlined"
              onChange={handleDistrictChange}
              options={districtOptions}
              defaultValue={modalDefaultValues?.district}
            />
            {errors?.district && errors.district?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="Municipality"
              name="municipality"
              variant="outlined"
              options={palikaOptions}
              onChange={handlePalikaNameChange}
              defaultValue={modalDefaultValues?.municipality}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Ward/Tole"
              type="number"
              size="small"
              variant="outlined"
              name="wardNumber"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.wardNumber}
              {...register("wardNumber", { required: true })}
            />
            {errors?.wardNumber && errors.wardNumber?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Guardian Name"
              type="text"
              size="small"
              variant="outlined"
              name="guardianName"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.guardianName}
              {...register("guardianName", { required: true })}
            />
            {errors?.guardianName && errors.guardianName?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Guardian Contact"
              type="number"
              size="small"
              variant="outlined"
              name="guardianContact"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.guardianContact}
              {...register("guardianContact", { required: true })}
            />
            {errors?.guardianContact && errors.guardianContact?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              name="sourceOfAdmission"
              label="Source of Admission**"
              variant="outlined"
              autoComplete="on"
              size="small"
              fullWidth
              options={SOURCE_OF_ADMISSION}
              defaultValue={modalDefaultValues?.sourceOfAdmission}
              onChange={handleCustomReactSelectChange}
            />
            {errors?.sourceOfAdmission && errors.sourceOfAdmission?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Investigation"
              size="small"
              variant="outlined"
              name="investigation"
              autoComplete="true"
              defaultValue={modalDefaultValues?.investigation}
              fullWidth
              {...register("investigation", { required: true })}
            />
            {errors?.investigation && errors.investigation?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Provisional Diagnosis"
              size="small"
              variant="outlined"
              name="provisionalDiagnosis"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.provisionalDiagnosis}
              {...register("provisionalDiagnosis", { required: true })}
            />
            {errors?.provisionalDiagnosis && errors.provisionalDiagnosis?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Treatment/Medicine Prescribed"
              size="small"
              variant="outlined"
              name="medicinePrescribed"
              autoComplete="true"
              defaultValue={modalDefaultValues?.medicinePrescribed}
              fullWidth
              {...register("medicinePrescribed", { required: true })}
            />
            {errors?.medicinePrescribed && errors.medicinePrescribed?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="Ayurvedic Therapy"
              size="small"
              variant="outlined"
              name="ayurvedicTherapy"
              autoComplete="true"
              fullWidth
              options={AYURVEDIC_THERAPY}
              defaultValue={modalDefaultValues?.ayurvedicTherapy}
              onChange={handleCustomReactSelectChange}
            />
            {errors?.ayurvedicTherapy && errors.ayurvedicTherapy?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Cost exemption Full"
              size="small"
              variant="outlined"
              name="costExemptionFull"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.costExemptionFull}
              {...register("costExemptionFull", { required: true })}
            />
            {errors?.costExemptionFull && errors.costExemptionFull?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Cost exemption Partial"
              size="small"
              variant="outlined"
              name="costExemptionPartial"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.costExemptionFull}
              {...register("costExemptionPartial", { required: true })}
            />
            {errors?.costExemptionFull && errors.costExemptionFull?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Total cost exempted"
              size="small"
              variant="outlined"
              name="totalCostExempted"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.totalCostExempted}
              {...register("totalCostExempted", { required: true })}
            />
            {errors?.totalCostExempted && errors.totalCostExempted?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Code"
              size="small"
              variant="outlined"
              name="code"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.code}
              {...register("code", { required: true })}
            />
            {errors?.code && errors.code?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="Police Case"
              size="small"
              variant="outlined"
              name="policeCase"
              autoComplete="true"
              fullWidth
              onChange={handleCustomReactSelectChange}
              defaultValue={modalDefaultValues?.policeCase}
              options={POLICE_CASE}
            />
            {errors?.policeCase && errors.policeCase?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
        </Grid>
      </CustomModal>
      <DeleteRegisterRecordConformation
        showDeleteModal={showAdmissionRegisterDeleteModal}
        closeDeleteModel={closeAdmissionDeleteModal}
        deleteRecord={deleteAdmissionRow}
      />
      <AdmissionRegister
        onEditRow={admissionSewaEdit}
        tableData={admisssionSewaTableData}
        deleteRow={onDeleteAdmissionRow}
        page={page}
        handleChangePage={handleChangePage}
        totalSize={totalSize}
        getTableData={(value) => setGetTableData(value)}
      />
    </>
  )
}

export default AdmissionForm;
